// src/App.js

import React, { Component } from 'react';
import Cookies from 'js-cookie';
import logo from './bhlogo.png';
import './App.css';

    class App extends Component {
      render() {
        const fullUrl = window.location.href;
        console.log('url: ', fullUrl)
        const urlParameters = fullUrl.split('?')[1].split('&');

        const subdomain = urlParameters[0];
        const portalName = urlParameters[1].replace(/%20/g, ' ');
        const organizationButtonText = urlParameters[2].replace(/%20/g, ' ');
        const organizationRedirectUrl = urlParameters[3];

        const organizationLogoUrl = `https://${subdomain}.benefithub.info/api/ResourceProxy/GetLogo`;

        return (
    <div className="App">
      <header className="App-header">
        <div className="logo">
          <img src={organizationLogoUrl} className="App-logo" alt="logo" />
        </div>
      </header>
      <main>
        <div className="App-form">
          <h4>{portalName}</h4>
          <div className="button">
            <button class="full" onClick={ () => {window.location = organizationRedirectUrl} }>
              {organizationButtonText ? organizationButtonText : 'Click Here to Log In'}
            </button>
          </div>
        </div>
      </main>
    </div>
        )
      }
    }

    export default App